<template>
    <v-container class="pa-5" fluid>
        <page-title>
            Materiały
        </page-title>

        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card class="mx-auto">
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Raport zapotrzebowania materiału
                                </v-card-title>

                                <v-card-text>
                                    <div class="text--primary">
                                        Raport zgłoszeń zapotrzebowania materiału na stanowisku raportowania.
                                    </div>

                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-menu
                                                v-model="menuFrom"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template #activator="{on}">
                                                    <v-text-field
                                                        v-model="filters.createdAt__gte"
                                                        label="Od"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        solo
                                                        hide-details
                                                        append-icon
                                                        clearable
                                                        class="mt-0"
                                                        v-on="on"
                                                        @click:clear="clearFilter('createdAt__gte')"
                                                    >
                                                        <template slot="append-outer">
                                                            <div class="d-flex flex-wrap">
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    class="mt-n2"
                                                                    data-sentry-label="Zmiana daty początku zakresu raportu"
                                                                    @click="getForwardDate('createdAt__gte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-up
                                                                    </v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    data-sentry-label="Zmiana daty początku zakresu raportu"
                                                                    @click="getBackwardDate('createdAt__gte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-down
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="filters.createdAt__gte"
                                                    first-day-of-week="1"
                                                    @input="menuFrom = false"
                                                />
                                            </v-menu>
                                        </v-col>

                                        <v-col cols="12" md="4">
                                            <v-menu
                                                v-model="menuTo"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template #activator="{on}">
                                                    <v-text-field
                                                        v-model="filters.createdAt__lte"
                                                        label="Do"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        solo
                                                        hide-details
                                                        append-icon
                                                        clearable
                                                        class="mt-0"
                                                        v-on="on"
                                                        @click:clear="clearFilter('createdAt__lte')"
                                                    >
                                                        <template slot="append-outer">
                                                            <div class="d-flex flex-wrap">
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    class="mt-n2"
                                                                    data-sentry-label="Zmiana daty końca zakresu raportu"
                                                                    @click="getForwardDate('createdAt__lte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-up
                                                                    </v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    data-sentry-label="Zmiana daty końca zakresu raportu"
                                                                    @click="getBackwardDate('createdAt__lte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-down
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="filters.createdAt__lte"
                                                    first-day-of-week="1"
                                                    @input="menuTo = false"
                                                />
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        :disabled="!isGenerateEnabled || actionLoading"
                                        @click="generateReport"
                                    >
                                        Generuj raport
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios'

import PageTitle from '@/components/common/PageTitle'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'MaterialReport',
    components: {
        PageTitle,
    },
    mixins: [
        dateFormatter,
    ],
    data() {
        return {
            filters: {
                createdAt__lte: null,
                createdAt__gte: null,
            },
            menuFrom: false,
            menuTo: false,
            actionLoading: false,
        }
    },
    computed: {
        isGenerateEnabled() {
            return Boolean(this.filters.createdAt__lte && this.filters.createdAt__gte)
        },
        userEmail() {
            return localStorage.getItem('userEmail')
        },
    },
    methods: {
        clearFilter(filterName) {
            this.filters[filterName] = null
        },
        getBackwardDate(field) {
            if (Date.parse(this.filters[field])) {
                this.filters[field] = this.getDayBackward(this.filters[field])
            }
        },
        getForwardDate(field) {
            if (Date.parse(this.filters[field])) {
                this.filters[field] = this.getDayForward(this.filters[field])
            }
        },
        async generateReport() {
            addSentryBreadcrumb('ui.action', 'Generowanie raportu zapotrzebowania materiału.')

            this.actionLoading = true
            try {
                await axios.get('/reports/report-material-reservations', {
                    params: {
                        report: true,
                        createdAt__gte: this.filters.createdAt__gte,
                        createdAt__lte: this.filters.createdAt__lte,
                    },
                    timeout: 120000,
                })

                this.$store.commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport zostanie wysłany na adres ${this.userEmail} w ciągu kilku minut.`
                }, { root: true })
            } catch (err) {
                errorHandler(err)
            } finally {
                this.filters = {
                    createdAt__lte: null,
                    createdAt__gte: null,
                }
                this.actionLoading = false
            }
        },
    }
}
</script>
